import * as React from "react";
import { MarketplaceTemplateCard } from "./templateCard";
import "./templateList.css";
import { sortBy } from "lodash";
import { Template } from "../types/template";
import { request } from "../../../services/cpln";
import { Loader } from "../../../components/layout/loader";
import { Alert } from "antd";
import { sentryLog } from "../../../tools/sentry";
import { getMarketplaceErrorMessage } from "../utils";

export const MarketplaceTemplateList: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [templates, setTemplates] = React.useState<Template[]>([]);

  React.useEffect(() => {
    fetchTemplates();
  }, []);

  async function fetchTemplates() {
    try {
      setIsLoading(true);
      setError("");
      const { data } = await request({ service: "marketplace", url: "/template" });
      setTemplates(Object.values(data.items));
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      const errorMessage = getMarketplaceErrorMessage(e);
      const errorString = Array.isArray(errorMessage) ? errorMessage.join("\n") : errorMessage;
      setError(errorString);
      if (errorString) {
        sentryLog("template catalog", {
          "data.exc": JSON.stringify({ response: e?.response || {}, message: e.message || "" }),
        });
      }
    }
  }

  // const placeholderEffect = usePlaceholderEffect();
  // return (
  //   <div className="text-xs">
  //     <pre>{JSON.stringify(templates, null, 2)}</pre>
  //   </div>
  // );

  return (
    <div className="template-list relative">
      <div className="mb-4 flex items-center justify-between gap-8">
        <div className="color-card-drop">Template Catalog</div>
        {/* {isLoading || error ? null : (
          <NGInput
            onFocus={() => placeholderEffect.setIsFilterFocused(true)}
            onBlur={() => placeholderEffect.setIsFilterFocused(false)}
            style={{ width: 364 }}
            placeholder={`${placeholderEffect.placeholder}${placeholderEffect.index % 2 === 0 ? "|" : ""}`}
          />
        )} */}
      </div>
      {isLoading ? (
        <Loader
          style={{
            width: 100,
            height: 100,
            margin: 0,
            left: `calc(50% - 50px)`,
            right: "unset",
            top: 150,
            bottom: "unset",
          }}
        />
      ) : error ? (
        <Alert type="error" message="Error" description={error} />
      ) : null}
      <div className="template-list-grid">
        {sortBy(templates, "folderName").map((template, index) => {
          return <MarketplaceTemplateCard key={index} template={template} />;
        })}
      </div>
    </div>
  );
};
